import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { api } from '../lib/api';

export function AuthCallback() {
  const { isSignedIn, isLoaded } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isLoaded) return;

    if (!isSignedIn) {
      // Not signed in — might need to wait for session activation
      const timer = setTimeout(() => {
        // After 10s, redirect to landing
        navigate('/', { replace: true });
      }, 10_000);
      return () => clearTimeout(timer);
    }

    // Signed in — check user status and route accordingly
    api.getMe()
      .then((data) => {
        if (data.instance) {
          navigate('/chat', { replace: true });
        } else {
          navigate('/deploy', { replace: true });
        }
      })
      .catch((err) => {
        console.error('Auth callback error:', err);
        setError(err.message);
        // Fallback: go to onboarding
        setTimeout(() => navigate('/deploy', { replace: true }), 2000);
      });
  }, [isSignedIn, isLoaded, navigate, searchParams]);

  return (
    <div className="auth-container">
      {error ? (
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <p style={{ color: 'var(--coral)', marginBottom: 16 }}>{error}</p>
          <p style={{ color: 'var(--text-muted)' }}>Redirecting...</p>
        </div>
      ) : (
        <>
          <div className="deploy-spinner" />
          <p style={{ color: 'var(--text-muted)' }}>Signing you in...</p>
        </>
      )}
    </div>
  );
}
